module.exports = __webpack_public_path__ + "img/image 15.96b4f330.png";